export default __webpack_public_path__ + "static/media/outside.142961a6.webp";